import {eConsentActionTypes} from "../actions/actionTypes";

const initialState = {
    signed: false,
    hasSignedOnce: false,
    revoked: false,
    revokeLogsOut: false,
};

export const eConsentReducer = (state = initialState, action) => {
    switch (action.type) {
        case eConsentActionTypes.SET_ECONSENT_DATA:
            return {
                ...state,
                ...action.payload,
            }
        case eConsentActionTypes.SET_ECONSENT_SIGNED:
            return {
                ...state,
                signed: action.payload,
                hasSignedOnce: state.hasSignedOnce || action.payload,
            }
        case eConsentActionTypes.SET_ECONSENT_REVOKED:
            return {
                ...state,
                revoked: true,
            }
        case eConsentActionTypes.SET_ECONSENT_REVOKE_LOGS_OUT:
            return {
                ...state,
                revokeLogsOut: action.payload === true,
            }
        default:
            return state
    }
}
